import { SmartfireComponent } from "@smartfire/gutenberg-react";
import * as React from "react";
import "./style.scss";
import "./editor.scss";
import CapsaTitle from "../CapsaTitle/block.js";
import PlusButton from "../plus-button/block.js";
import CapsaTitleMiniature from "../capsa-title-miniature/capsaTitleMiniature.js";

export default class BlocklistDetailsBlock extends SmartfireComponent {
  constructor(props) {
    super(props);

    this.state = { width: props.width, eventData: null };
  }
  componentWillMount() {
    this.setState({ width: window.innerWidth });

    this.setState({
      eventData: { productId: this.props.id, productTitle: this.props.title },
    });
    if (this.props.type === "job-offers") {
      this.setState({
        eventData: {
          jobTitle: this.props.title,
          productTitle: this.props.title,
          productId: this.props.id,
        },
      });
    }
  }

  render() {
    return (
      <div className={"product-details-block " + this.props.type}>
        {this.props.descriptionImage && (
          <div
            className="background-image"
            style={{
              backgroundImage: "url(" + this.props.descriptionImage + ")",
            }}
          />
        )}
        <div className="main-content">
          {this.props.title !== "" && this.state.width <= 530 ? (
            <CapsaTitleMiniature title={this.props.title} />
          ) : (
            <CapsaTitle title={this.props.title} position="left" />
          )}
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: this.props.longDescription }}
          />
          <div className="columns">
            {this.props.columns &&
              this.props.columns.map((column, i) => {
                //we display the column if there is at least one value inside
                let filtered = column.rows.filter(function (el) {
                  return el !== "";
                });
                if (Array.isArray(column.rows) && filtered.length) {
                  return (
                    <div className="column">
                      <h3>{column.title}</h3>
                      <ul>
                        {column.rows.map((row, i) => {
                          if (row !== "")
                            return (
                              <li dangerouslySetInnerHTML={{ __html: row }} />
                            );
                          return null;
                        })}
                      </ul>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
          </div>
          <div className="buttons">
            {this.props.buttons &&
              this.props.buttons.map((button, i) => (
                <PlusButton
                  buttonText={button.title}
                  buttonUrl={button.url}
                  event={button.event}
                  target="blank"
                  eventData={this.state.eventData}
                />
              ))}
            {this.props.showDetailsUrl && (
              <PlusButton
                buttonText={"Fiche produit"}
                buttonUrl={this.props.showDetailsUrl}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
